// extracted by mini-css-extract-plugin
export default {"list":"styles_list__uqIoa","item":"styles_item__FTQtj"};